"use client";

import { useMutation } from "@tanstack/react-query";
import { authClient } from "@/db/auth/client";
import { toast } from "@garagem/ui/components/sonner";

// Password management hooks
export function useChangePassword() {
  return useMutation({
    mutationFn: async ({
      currentPassword,
      newPassword,
    }: {
      currentPassword: string;
      newPassword: string;
    }) => {
      const response = await authClient.changePassword({
        currentPassword,
        newPassword,
      });
      if (response.error) throw response.error;
      return response.data;
    },
    onSuccess: () => {
      toast.success("Senha alterada com sucesso!");
    },
    onError: (error) => {
      const errorCode = (error as { code?: string })?.code;
      const errorMessage = error?.message || "Erro ao atualizar senha";

      if (errorCode === "INVALID_PASSWORD") {
        throw new Error("Senha atual incorreta");
      } else if (errorCode === "WEAK_PASSWORD") {
        throw new Error("A nova senha não atende aos critérios de segurança");
      } else {
        throw new Error(errorMessage);
      }
    },
  });
}

